import { Injectable } from '@angular/core';
import type { UserDelegationFindManyQueryInterface } from '@zaoblako/shared/modules/security/dtos/user-delegation/user-delegation-find-many-query.dto';
import type { UserDelegationFindInterface } from '@zaoblako/shared/modules/security/dtos/user-delegation/user-delegation-find.dto';
import type { UserDelegationPageInterface } from '@zaoblako/shared/modules/security/dtos/user-delegation/user-delegation-page.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserDelegationService extends BaseService {
  protected baseUrl = '/basis/security/user-delegation';

  public findWithPagination(
    queryParams: UserDelegationFindManyQueryInterface
  ): Observable<UserDelegationPageInterface> {
    return this.http.get<UserDelegationPageInterface>(this.baseUrl, { params: this.objectToHttpParams(queryParams) });
  }

  public restore(id: number): Observable<UserDelegationFindInterface> {
    return this.http.post<UserDelegationFindInterface>(`${this.baseUrl}/${id}/restore`, null);
  }
}
